<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<path d="M15,4.6v6.8l-4-2V6.6L15,4.6 M16,3l-6,3v4l6,3V3L16,3z" />
	<polygon points="5,10 0,13 0,3 5,6" />
	<rect x="7" y="13" width="1" height="2" />
	<rect x="7" y="9" width="1" height="2" />
	<rect x="7" y="5" width="1" height="2" />
	<rect x="7" y="1" width="1" height="2" />
</svg>
</template>